import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "@/context/LanguageContext";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import WhatIsReiki from "@/pages/WhatIsReiki";
import Mission from "@/pages/Mission";
import Book from "@/pages/Book";
import FutureInterest from "@/pages/FutureInterest";
import FutureServices from "@/pages/FutureServices";
import Certificates from "@/pages/Certificates";
import Contact from "@/pages/Contact";
import Fundraiser from "@/pages/Fundraiser";
import SupportMe from "@/pages/SupportMe";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import UserDashboard from "@/pages/UserDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import AuthCallback from "@/pages/AuthCallback";
import Promo from "@/pages/Promo";

function ProtectedRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="container-refined py-24 text-forest-700">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function AppShell() {
  const location = useLocation();
  // CRITICAL: process Google OAuth callback BEFORE any protected route runs
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/what-is-reiki" element={<WhatIsReiki />} />
        <Route path="/mission" element={<Mission />} />
        <Route path="/book" element={<Book />} />
        <Route path="/future-interest" element={<FutureInterest />} />
        <Route path="/future-services" element={<FutureServices />} />
        <Route path="/certificates" element={<Certificates />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/fundraiser" element={<Fundraiser />} />
        <Route path="/support" element={<SupportMe />} />
        <Route path="/promo" element={<Promo />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/account" element={<ProtectedRoute><UserDashboard /></ProtectedRoute>} />
        <Route path="/admin" element={<ProtectedRoute adminOnly><AdminDashboard /></ProtectedRoute>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <AuthProvider>
          <AppShell />
          <Toaster position="top-center" richColors closeButton />
        </AuthProvider>
      </LanguageProvider>
    </BrowserRouter>
  );
}
